import React from 'react';
import { useUIStore } from '@/store/uiStore';
import CreateSupplierModal from './CreateSupplierModal';
import EditSupplierModal from './EditSupplierModal';
import SupplierDetailModal from './SupplierDetailModal';
import PaymentModal from './PaymentModal';
import DiscountModal from './DiscountModal';
import ExportDebtModal from './ExportDebtModal';

const SupplierModals: React.FC = () => {
  const { modals, closeModal, selectedSupplier } = useUIStore();

  return (
    <>
      <CreateSupplierModal />
      <EditSupplierModal />

      <SupplierDetailModal
        isOpen={modals.supplierDetail || false}
        onClose={() => closeModal('supplierDetail')}
        supplierId={selectedSupplier}
      />

      <PaymentModal />
      <DiscountModal />
      <ExportDebtModal />
    </>
  );
};

export default SupplierModals;

// Export individual components
export {
  CreateSupplierModal,
  EditSupplierModal,
  SupplierDetailModal,
  PaymentModal,
  DiscountModal,
  ExportDebtModal,
};

// Export tab components
export { default as SupplierInfoTab } from './SupplierInfoTab';
export { default as SupplierWarehouseReceiptHistoryTab } from './SupplierWarehouseReceiptHistoryTab';
